import type { FaireProductEntity } from "../../entity_types/product";

export const p_66237wv5b8: FaireProductEntity = {
  token: "p_66237wv5b8",
  type: "product",
  name: "ILY Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/dae709a26e2c5dc65a0eca5f4d2834abf8c97ac67476a74b315a17f59311fb92.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6f1fd1dafd242ef50fe46119c3e156b96fe1d872834cb95f1fa507c130347eb3.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:53.867Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
